//
//
//
//
//
//
//

export default {
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick () {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/swipeout/swipeout-button.vue